import '../styles/LandingProductExplanation.css';
import React from 'react';

const READOUTS = [
  {
    index: '01',
    label: 'Account setup',
    value: 'Create an account',
    note: 'Start a client account and establish the identity that carries every measurement thereafter.',
  },
  {
    index: '02',
    label: 'Balance readout',
    value: 'Check your balance',
    note: 'Read the current position of the account as a single, exact figure — nothing estimated, nothing rounded away.',
  },
  {
    index: '03',
    label: 'Movement',
    value: 'Transfer funds',
    note: 'Move money between accounts with the amount confirmed before it leaves the instrument.',
  },
  {
    index: '04',
    label: 'Record',
    value: 'View transfer history',
    note: 'Return to the ruled ledger of past transfers and read each entry as a dated, itemised record.',
  },
];

function LandingProductExplanation() {
  return (
    <section
      className="lpe-section"
      id="product-explanation"
      aria-labelledby="lpe-heading"
    >
      <svg
        className="lpe-contour"
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 1440 640"
        preserveAspectRatio="none"
      >
        <g fill="none" stroke="rgba(242,239,233,0.05)" strokeWidth="1">
          <path d="M-40 120 C 220 60, 460 190, 760 120 S 1220 40, 1480 130" />
          <path d="M-40 200 C 240 140, 480 260, 780 195 S 1240 120, 1480 210" />
          <path d="M-40 285 C 200 235, 500 330, 800 275 S 1240 210, 1480 300" />
          <path d="M-40 370 C 220 320, 520 420, 820 360 S 1260 300, 1480 390" />
          <path d="M-40 460 C 240 410, 500 500, 840 450 S 1280 400, 1480 480" />
          <path d="M-40 555 C 200 505, 520 590, 860 545 S 1300 500, 1480 570" />
        </g>
      </svg>

      <div className="lpe-inner">
        <header className="lpe-head">
          <span className="lpe-mark">Online banking system</span>
          <h2 className="lpe-heading" id="lpe-heading">
            One instrument for your account
          </h2>
          <p className="lpe-lede">
            <strong>online-banking-account</strong> is an online banking system for
            retail clients and the bank staff who service them. It is built for
            adults who need to trust a bank with money: the account, the balance,
            every transfer and every record are measured to the figure, not
            described in round numbers.
          </p>
          <p className="lpe-lede">
            There are four things the system does, and they are the whole of it.
            You begin, you read your position, you move funds, and you return to
            the record of what moved.
          </p>
        </header>

        <div className="lpe-readouts">
          {READOUTS.map((item) => (
            <article className="lpe-row" key={item.label}>
              <span className="lpe-index" aria-hidden="true">
                {item.index}
              </span>
              <span className="lpe-label">{item.label}</span>
              <span className="lpe-value">{item.value}</span>
              <span className="lpe-note">{item.note}</span>
            </article>
          ))}
        </div>

        <div className="lpe-begin">
          <span className="lpe-begin-label">To begin</span>
          <p className="lpe-begin-copy">
            Enrolment is self-service: open an account and the instrument is
            calibrated to you from the first reading. If you already hold an
            account, <strong>sign in</strong> to return to it.
          </p>
        </div>
      </div>
    </section>
  );
}

export default LandingProductExplanation;